import VDraggable from './VDraggable'

export { VDraggable }

export default VDraggable